import AlertType from 'common/types/AlertType';
import React from 'react';
import { useLocation } from 'react-router-dom';
import Alert from '../alert/Alert';
import { PageTemplates } from './PageTemplates';

interface IPage {
  children?: React.ReactNode;
  className?: string;
  template: PageTemplates;
}

function getClassname(classname: string, template: PageTemplates) {
  if (classname) {
    return classname;
  }
  switch (template) {
    case PageTemplates.fullWidth:
      return 'col-12';
    case PageTemplates.truncated:
      return 'col-md-10';
    case PageTemplates.centered:
      return 'col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12';
    case PageTemplates.truncateOffset1:
      return 'col-md-9 offset-md-1';
  }
}

const Page = (props: IPage) => {
  const { state } = useLocation<Record<string, string>>();

  return (
    <div
      data-testid='page-template'
      className={getClassname(props.className || '', props.template)}
    >
      {state && state.message && (
        <Alert type={state.type as AlertType}>{state.message}</Alert>
      )}
      {props.children}
    </div>
  );
};

export default Page;
